<template>
  <b-modal title="Carta Gráfica" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="7">
          <apexchart width="700" type="area" :options="options" :series="series"></apexchart>
        </b-col>
        <b-col cols="1"></b-col>
        <b-col cols="4">
          <b-row>
            <h5><strong>Atributos da Carta Gráfica</strong></h5>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row>
            <b-col cols="6">
              <b-form-group label="Teto:" label-for="teto" label-cols="4" label-align="left">
                <b-form-input id="teto" type="number" v-model="carta.teto" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Carga:" label-for="aplicar" label-cols="4" label-align="left">
                <b-form-input id="aplicar" type="number" v-model="carta.aplicar" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Taxa:" label-for="taxa" label-cols="4" label-align="left">
                <b-form-input id="taxa" type="number" v-model="carta.taxa" />
              </b-form-group>
            </b-col>
            <b-col cols="6"> </b-col>
            <b-col cols="6" class="mb-4 text-rigth">
              <b-button size="sm" class="" variant="danger" @click="aplicar()">
                <b-icon icon="compass-fill" variant="light" scale="1.1" class="mr-2" />Aplicar Carga
              </b-button>
            </b-col>
            <b-col cols="6"> </b-col>
            <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6">
              <b-form-group label="Tempo:" label-for="duracao" label-cols="4" label-align="right">
                <b-form-input id="duracao" type="number" v-model="carta.duracao" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Fator:" label-for="ajuste" label-cols="4" label-align="left">
                <b-form-input id="ajuste" type="number" v-model="carta.ajuste" />
              </b-form-group>
            </b-col>

            <b-col cols="6" class="mb-4 text-rigth">
              <b-button size="sm" class="" variant="warning" @click="manter()">
                <b-icon icon="compass-fill" variant="light" scale="1.1" class="mr-2" />Manter Carga
              </b-button>
            </b-col>
            <b-col cols="6"> </b-col>
            <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6">
              <b-form-group label="Alivio:" label-for="alivio" label-cols="4" label-align="right">
                <b-form-input id="alivio" type="number" v-model="carta.alivio" />
              </b-form-group>
            </b-col>
            <b-col cols="6"> </b-col>
            <b-col cols="6" class="mb-4 text-rigth">
              <b-button size="sm" class="" variant="info" @click="remover()">
                <b-icon icon="compass-fill" variant="light" scale="1.1" class="mr-2" />Remover
              </b-button>
            </b-col>
            <b-col cols="6"> </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button class="" variant="info" @click="plotar()">
        <b-icon icon="graph-up" variant="light" scale="1.1" class="mr-2" />Plotar Gráfico
      </b-button>
      <b-button class="" variant="warning" @click="limpar()">
        <b-icon icon="graph-down" variant="light" scale="1.1" class="mr-2" />Limpar Gráfico
      </b-button>
      <b-button class="" variant="danger" @click="zerar()">
        <b-icon icon="graph-down" variant="light" scale="1.1" class="mr-2" />Zerar Gráfico
      </b-button>
      <b-button class="" variant="success" @click="loadGrafico()">
        <b-icon icon="graph-up" variant="light" scale="1.1" class="mr-2" />Enviar Gráfico
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "ModalDeCartaGrafica",

  components: {
    apexchart: VueApexCharts,
  },

  data() {
    return {
      show: false,
      carta: { aplicar: 0, taxa: 10, teto: 100, duracao: 300, ajuste: 0, tempoAl: 60, alivio: 0 },
      series: [{ name: "series", data: [] }],
      dados: [{ name: "teste", data: [] }],
      duracao: 0,
      valor: 0,
      options: {
        chart: {
          id: "teste-chart",
          background: "#BABABA",
          toolbar: {
            show: false,
            autoSelected: "pan",
          },
          dataLabels: {
            enabled: true,
          },
        },
        xaxis: {
          show: true,
          categories: [0, 300, 600, 900, 1200, 1500, 1800],
          type: "numeric",
          title: {
            text: "Tempo(Segundos)",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: "Carga/Pressão",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: 'dark',
            shadeIntensity: 1,
            opacityFrom: 0.3,
            opacityTo: 0.1,
            stops: [0, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#EE0000", "#E91E63"],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "round",
          width: 2,
        },
        title: {
          text: "CARTA GRÁFICA DE TESTE",
          align: "center",
        },
      },
    };
  },

  methods: {
    aplicar() {
      // Cria uma zona inconsistente inicial baseada na taxa de variação
      var inicioTeste = Math.floor(Math.random() * 120);
      for (this.duracao; this.duracao < inicioTeste; this.duracao++) {
        this.dados[0].data.push({ x: this.duracao, y: Math.floor(Math.random() * this.carta.taxa) });
      }
      // Aplica a carga desejada com fatores de ajuste variaveis
      do {
        this.duracao++;
        var resultado = Math.floor(Math.random() * 10);
        var fator = Math.floor(Math.random() * 12);
        if (resultado == 3 || resultado == 5 || resultado == 7) {
          for (var j = 0; j < fator; j++) {
            this.valor = this.valor + Number(this.carta.taxa);
            this.dados[0].data.push({ x: this.duracao, y: this.valor });
            this.duracao++;
          }
        }
        var aplicar = Math.floor(Math.random() * Number(this.carta.taxa)) + Number(this.carta.aplicar);
        this.valor = this.valor + aplicar;
        this.dados[0].data.push({ x: this.duracao, y: this.valor });
      } while (this.valor <= this.carta.teto);
    },

    manter() {
      // Cria uma zona inconsistente que passa a ser estavel após o processo
      var manterTeste = this.duracao + Math.floor(Math.random() * 50);
      this.duracao++;
      for (this.duracao; this.duracao < manterTeste; this.duracao++) {
        var resultado = Math.floor(Math.random() * 10) % 2 == 0 ? "Par" : "Impar";
        if (resultado == "Par") {
          this.dados[0].data.push({ x: this.duracao, y: this.valor + Number(this.carta.ajuste) });
        } else {
          this.dados[0].data.push({ x: this.duracao, y: this.valor - Number(this.carta.ajuste) });
        }
      }

      for (var i = 0; i < this.carta.duracao; i++) {
        // Cria uma ajuste negativo
        var manterAjuste = Math.floor(Math.random() * 10);
        if (manterAjuste == 3 || manterAjuste == 7) {
          this.valor = this.valor - Number(this.carta.ajuste);
          this.dados[0].data.push({ x: this.duracao, y: this.valor });
          this.duracao++;
        }
        // Cria uma ajuste positivo
        if (manterAjuste == 4 || manterAjuste == 8) {
          this.valor = this.valor + Number(this.carta.ajuste);
          this.dados[0].data.push({ x: this.duracao, y: this.valor });
          this.duracao++;
        }
        this.dados[0].data.push({ x: this.duracao, y: this.valor });
        this.duracao++;
      }
    },

    remover() {
      // Remove a carga baseada no valor de alivio até zerar
      do {
        this.duracao++;
        if (this.valor < this.carta.alivio) {
          this.valor = 0;
          this.dados[0].data.push({ x: this.duracao, y: this.valor });
        } else {
          this.valor = this.valor - this.carta.alivio;
          this.dados[0].data.push({ x: this.duracao, y: this.valor });
        }
      } while (this.valor > 0);
      // Cria uma zona de final
      var finalTeste = this.duracao + Math.floor(Math.random() * 30);
      for (this.duracao; this.duracao < finalTeste; this.duracao++) {
        this.dados[0].data.push({ x: this.duracao, y: Math.floor(Math.random() * this.carta.ajuste) });
      }
    },

    plotar() {
      this.series = this.dados;
    },

    limpar() {
      this.series = [{ name: "series", data: [] }];
    },

    zerar() {
      this.series = [{ name: "series", data: [] }];
      this.dados = [{ name: "teste", data: [] }];
      this.duracao = 0;
      this.valor = 0;
    },

    loadGrafico() {
      this.$emit("loadGrafico", this.series);
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
